export const DashboardThemes = {
  LIGHT: "light",
  DARK: "dark",
} as const;

export const SidebarTypes = {
  SOLID: "solid",
  TRANSPARENT: "transparent",
} as const;

export const NavbarTypes = {
  STATIC: "static",
  FLOATING: "floating",
} as const;

/** Sidebar theme keys map to `.dashboard-{key}` CSS classes */
export const SIDEBAR_COLORS = {
  third: "#483CB6", // Sing purple (featured)
  dark: "#002B49",
  sea: "#004472",
  first: "#3D3D3D",
  second: "#4B505F",
  indigo: "#2F2A6B",
  burgundy: "#6B2D3C",
  fifth: "#20AE8C",
  teal: "#0F766E",
  sky: "#E9EBEF",
  wave: "#D1E7F5",
  fourth: "#EFF2F5",
  cream: "#fff4ee",
  light: "#FFFFFF",
} as const;

export const NAVBAR_COLORS = {
  first: "#FFFFFF",
  lavender: "#C9D1FB", // Sing pale blue/lavender (featured)
  mist: "#D6E4FF",
  second: "#E2E7EC",
  softGray: "#C1C3CF",
  blush: "#F3D9E2",
  mint: "#D8F3E8",
  peach: "#FFE8D6",
  ice: "#E8F1F8",
  navy: "#0C2236",
  skyBlue: "#6FB0F9",
  lilac: "#E4D4F5",
} as const;
